module.exports = __webpack_public_path__ + "static/media/BETH-ETH.d8c7648d.svg";